import { createSlice } from "@reduxjs/toolkit";

const emailLogSlice = createSlice({
  name: "emailLog",
  initialState: {
    logs: [],
    totalLogs: 0,
    currentPage: 0,
    isLoading: false,
    isResending: false,
    searchValue: "",
    filterType: "",
    filterStatus: "",
    filterDateRange: [],
    itemPerPage: 25,
    selected: [],
    emailTypeDropdown: [],
    error: null,
  },
  reducers: {
    setLogs(state, action) {
      state.logs = action.payload.data || [];
      state.totalLogs = action.payload.total || 0;
      state.currentPage = action.payload.page || 0;
      state.isLoading = false;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
      if (action.payload) state.error = null;
    },
    setResending(state, action) {
      state.isResending = action.payload;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setTypeFilter(state, action) {
      state.filterType = action.payload;
    },
    setStatusFilter(state, action) {
      state.filterStatus = action.payload;
    },
    setDateRangeFilter(state, action) {
      state.filterDateRange = action.payload;
    },
    setItemPerPage(state, action) {
      state.itemPerPage = action.payload;
    },
    setPage(state, action) {
      state.currentPage = action.payload;
    },
    setSelected(state, action) {
      state.selected = action.payload;
    },
    setEmailTypeDropdown(state, action) {
      state.emailTypeDropdown = action.payload;
    },
    resetFilter(state) {
      state.searchValue = "";
      state.filterType = "";
      state.filterStatus = "";
      state.filterDateRange = [];
    },
    clearEmailLogs(state) {
      state.logs = [];
      state.totalLogs = 0;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setLogs,
  setLoading,
  setResending,
  setSearchValue,
  setTypeFilter,
  setStatusFilter,
  setDateRangeFilter,
  setItemPerPage,
  setPage,
  setSelected,
  setEmailTypeDropdown,
  resetFilter,
  clearEmailLogs,
  setError,
} = emailLogSlice.actions;
export default emailLogSlice.reducer;
